import { ReactComponent as IBacklink } from "../../../../assets/icons/backlink.svg";
import { ReactComponent as IBacklinkBlack } from "../../../../assets/icons/backlink-black.svg";
import { Link } from "react-router-dom";
import "./navbar-item.sass";

type Props = {
  title: string;
  isBacklink?: boolean;
  link: string;
  theme?: "white" | "blue";
};

const NavbarItem = ({ link, title, isBacklink, theme }: Props) => {
  return (
    <Link to={link} className="navbar-item">
      {title}

      {isBacklink && theme === "blue" && (
        <IBacklink className="navbar-item__backlink" />
      )}

      {isBacklink && theme === "white" && (
        <IBacklinkBlack className="navbar-item__backlink" />
      )}
    </Link>
  );
};

export default NavbarItem;
